module.exports = __webpack_public_path__ + "img/sec03-05.d5fbc515.png";